module.exports = __webpack_public_path__ + "img/facebook.3594d406.svg";